export const CONVERT_TYPE = 'Conversion'
